module.exports = __webpack_public_path__ + "static/media/PilbaraNews-devicecomp-min@2x.997ab7fc.png";